import React, {useState} from 'react';
import { Link } from 'react-router-dom';
import { Alert, Card, Col, Container, Input, Label, Row ,Button} from 'reactstrap';
import AuthSlider from '../authCarousel';
import axios from 'axios';

import logoTelkom from "../../../assets/images/telkom/logoACI.png";
import Welcome from "../../../assets/images/telkom/welcomeNew.png";

const CoverSignUpterview = () => {
    document.title="Register Admin";

    // ---- Input Data Login ---- //
    const [nama, setNama] = useState('');
    const [errorNama, setErrorNama] = useState('');
    const [email, setEmail] = useState('');
    const [errorEmail, setErrorEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorPassword, setErrorPassword] = useState('');
    const [confPassword, setConfPassword] = useState('');
    const [special, setSpecial] = useState('');
    const [errorConfPassword, setErrorConfPassword] = useState('');

    // ---- Alert Error ---- //
    const [errorSubmit, setErrorSubmit] = useState(true);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorEmailSama, setErrorEmailSama] = useState(true);
    const [errorPasswordSama, setErrorPasswordSama] = useState(true);

    // -- Tombol Show Password -- //
    const [showPass, setShowPass] = useState(false);
    const [showConfPass, setShowConfPass] = useState(false);


    // --- NO DOUBLE CLICK ! --- //
    const [isDouble, setIsDouble] = useState(false)

    // ---- onChange Input Data ---- //
    const changeNama = (event) => {
        const value = event.target.value
        setNama(value)
        if(!value) {
            setErrorNama('Maaf, nama tidak boleh kosong!')
        }else{
            setErrorNama('')
        }
    }
    const changeEmail = (event) => {
        const value = event.target.value
        setEmail(value)
        if(!value) {
            setErrorEmail('Maaf, email tidak boleh kosong!')
        }else{
            setErrorEmail('')
        }
    }
    const changePassword= (event) => {
        const value = event.target.value
        setPassword(value)
        if(!value) {
            setErrorPassword('Maaf, password tidak boleh kosong!')
        }else{
            setErrorPassword('')
        }
    }
    const changeConfPassword = (event) => {
        const value = event.target.value
        setConfPassword(value)
        if(!value) {
            setErrorConfPassword('Maaf, password tidak boleh kosong!')
        } else if (password !== value) {
            setErrorConfPassword('Password tidak cocok')
        }
        else{
            setErrorConfPassword('')
        }
    }
    const changeSpecial= (event) => {
        const value = event.target.value
        setSpecial(value)
    }

    // -- Tombol Show Password -- //
    const shower = () => {
        setShowPass(!showPass);
    }
    const showerConf = () => {
        setShowConfPass(!showConfPass);
    }

    // -- Fungsi Get Error Message dari Error Code -- //
    const getErrorMessage = (errorCode) => {
        switch (errorCode) {
            case "E1":
                return "Sesi Anda telah berakhir. Silakan login kembali.";
            case "CE1":
            case "CE2":
                return "Data tidak valid. Silakan periksa kembali.";
            case "IF1":
                return "Data yang diminta tidak tersedia.";
            case "CE3":
                return "Kode tidak dapat digunakan.";
            case "SE1":
                return "Email tidak dapat digunakan.";
            case "PM1":
                return "Email atau password tidak valid.";
            case "PM2":
                return "Konfirmasi password tidak sesuai.";
            case "IF2":
                return "Data tidak lengkap.";
            case "EF1":
                return "Permintaan tidak dapat diproses.";
            case "OM1":
                return "Kode verifikasi tidak valid.";
            case "NC1":
                return "Konfirmasi password tidak sesuai.";
            case "AP1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "EX1":
                return "File tidak dapat diproses.";
            case "NX1":
                return "File belum dipilih.";
            case "AK1":
                return "Akses tidak valid.";
            case "FS1":
                return "Ukuran file melebihi batas maksimum yang diizinkan.";
            case "SQ1":
                return "Terjadi kesalahan sistem. Silakan coba kembali.";
            case "MN1":
                return "Gagal memproses file. Silakan coba kembali.";
            case "EV1":
                return "Data yang dikirim tidak valid.";
            case "NM1":
                return "Gagal mengirim notifikasi. Silakan coba kembali.";
            case "RL1":
                return "Terlalu banyak permintaan. Silakan coba kembali beberapa saat lagi.";
            default:
                return errorCode;
        }
    }

    // -- Fungsi Register-- //
    const registerButton = () => {
        setErrorEmailSama(true)
        setIsDouble(true)

        const data = JSON.stringify({
            nama: nama,
            email: email,
            password: password,
            confPassword: confPassword,
            passwordAdmin: special,
        });

        const config = {
            method: 'post',
            url: `${process.env.REACT_APP_BASE_ENDPOINT_BACKEND}/admin/register`,
            headers: {
                'Content-Type': 'application/json',
            },
            data: data,
        };

        axios(config).then((response) => {
            const statusCode = response.status;
            console.log(response)

            // Check if response contains error code
            if (response.data && response.data.error) {
                const errorCode = response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessage(message);
                setErrorSubmit(false);
                setTimeout(() => {
                    setErrorSubmit(true)
                    setErrorMessage('')
                }, 5000)
                setIsDouble(false)
                return;
            }

            if(statusCode === 200 ) {
                window.location.href = "/login-admin"
            }
            if(statusCode === 403 ) {
                setErrorEmailSama(false)
                setTimeout(() => {
                    setErrorEmailSama(true)
                }, 5000)
            }
            if(statusCode === 401 ) {
                setErrorPasswordSama(false)
                setTimeout(() => {
                    setErrorPasswordSama(true)
                }, 5000)
            }
            setIsDouble(false)
        }).catch((error) => {
            setIsDouble(false)
            console.log(error)

            if (error.response && error.response.data && error.response.data.error) {
                const errorCode = error.response.data.error;
                const message = getErrorMessage(errorCode);
                setErrorMessage(message);
                setErrorSubmit(false);
                setTimeout(() => {
                    setErrorSubmit(true)
                    setErrorMessage('')
                }, 5000)
            } else {
                setErrorMessage("Terjadi kesalahan. Silakan coba kembali.");
                setErrorSubmit(false);
                setTimeout(() => {
                    setErrorSubmit(true)
                    setErrorMessage('')
                }, 5000)
            }
        })
    }

    return (
        <React.Fragment>
            <style>
                {`
                    @keyframes slideDown {
                        from {
                            opacity: 0;
                            transform: translateY(-10px);
                            max-height: 0;
                        }
                        to {
                            opacity: 1;
                            transform: translateY(0);
                            max-height: 100px;
                        }
                    }
                `}
            </style>
        <Row style={{margin: '0px', height: '100vh', alignItems: 'center', fontFamily: 'Nunito'}}>

            {/* Ini Welcome! Lets Get Started */}
            <Col md={12} lg={6} xl={6} style={{height: '100%', padding: '0px'}}>
                <img src={Welcome} style={{height: '-webkit-fill-available'}}/>
            </Col>

            <Col md={12} lg={6} xl={6} style={{padding: '0px', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                <div style={{display: 'flex', justifyContent: 'center', marginRight: '50px'}}>
                    <img src={logoTelkom} />
                </div>

                <div style={{marginTop: '50px', padding: '25px', boxShadow: '0px 4px 15px rgba(0, 0, 0, 0.08)', borderRadius: '8px', width: '65%', marginRight: '50px'}}>
                                                    
                    {/* ---- HEADER Daftar ---- */}
                    <p style={{fontWeight: '700', fontSize: '30px', color: '#F56565', textAlign: 'center', margin: '0'}}>Daftar</p>
                    
                    {!errorEmailSama && (
                        <Alert 
                            color="danger" 
                            style={{ 
                                textAlign: 'center', 
                                backgroundColor: '#FEE2E2', 
                                color: '#DC2626', 
                                borderColor: '#FCA5A5', 
                                borderLeft: '4px solid #DC2626',
                                margin: '10px 0px 20px 0px', 
                                borderRadius: '6px',
                                padding: '12px 16px',
                                fontSize: '14px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                animation: 'slideDown 0.3s ease-out',
                                boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                            }}
                            onClose={() => {
                                setErrorEmailSama(true);
                            }}
                            toggle={() => {
                                setErrorEmailSama(true);
                            }}
                        >
                            <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                            Email sudah di gunakan
                        </Alert>
                    )}

                    {!errorSubmit && errorMessage && (
                        <Alert 
                            color="danger" 
                            style={{ 
                                textAlign: 'center', 
                                backgroundColor: '#FEE2E2', 
                                color: '#DC2626', 
                                borderColor: '#FCA5A5', 
                                borderLeft: '4px solid #DC2626',
                                margin: '10px 0px 20px 0px', 
                                borderRadius: '6px',
                                padding: '12px 16px',
                                fontSize: '14px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                animation: 'slideDown 0.3s ease-out',
                                boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                            }}
                            onClose={() => {
                                setErrorSubmit(true);
                                setErrorMessage('');
                            }}
                            toggle={() => {
                                setErrorSubmit(true);
                                setErrorMessage('');
                            }}
                        >
                            <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                            {errorMessage}
                        </Alert>
                    )}

                    {!errorPasswordSama && (
                        <Alert 
                            color="danger" 
                            style={{ 
                                textAlign: 'center', 
                                backgroundColor: '#FEE2E2', 
                                color: '#DC2626', 
                                borderColor: '#FCA5A5', 
                                borderLeft: '4px solid #DC2626',
                                margin: '10px 0px 20px 0px', 
                                borderRadius: '6px',
                                padding: '12px 16px',
                                fontSize: '14px',
                                fontWeight: '500',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                gap: '8px',
                                animation: 'slideDown 0.3s ease-out',
                                boxShadow: '0 2px 4px rgba(220, 38, 38, 0.1)'
                            }}
                            onClose={() => {
                                setErrorPasswordSama(true);
                            }}
                            toggle={() => {
                                setErrorPasswordSama(true);
                            }}
                        >
                            <i className="ri-error-warning-line" style={{ fontSize: '18px' }}></i>
                            Password harus sama Confirm Password
                        </Alert>
                    )}

                    {/* ---- Masukin Data Nama ---- */}
                    <div className="mb-3">
                        <Label htmlFor="nama" className="form-label">Nama</Label>
                        <Input value={nama} onChange={changeNama} type="text" className="form-control" id="nama" placeholder="Ketik nama Anda" required minLength={2} maxLength={100} />
                        <p style={{margin: '0', color: '#ED8936', fontSize: '14px'}}>*Nama setidaknya 2 - 20 karakter</p>
                        {errorNama && (
                            <p style={{margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute'}}>{errorNama}</p>
                        )}
                    </div>

                    {/* ---- Masukin Data Email ---- */}
                    <div className="mb-3">
                        <Label htmlFor="email" className="form-label">Email</Label>
                        <Input value={email} onChange={changeEmail} type="text" className="form-control" id="email" placeholder="Ketik email Anda" pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$" title="contoh@bebas.com" required maxLength={60}/>
                        {errorEmail && (
                            <p style={{margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute'}}>{errorEmail}</p>
                        )}
                    </div>

                    {/* ---- Masukin Data Password ---- */}
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="password-input">Password</Label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input value={password} onChange={changePassword} type={showPass ? "text" : "password"} className="form-control pe-5" placeholder="Masukan password" id="password-input" pattern='^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*_=+-]).{8,24}$' title="Password 8-24 character, setidaknya ada satu huruf kecil, huruf besar, angka dan simbol" required minLength={8} maxLength={24}/>
                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={shower} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                            </div>
                            <p style={{margin: '0', color: '#ED8936', fontSize: '14px'}}>*Kata sandi minimal 8 karakter harus terdiri atas huruf kapital, angka, dan simbol.</p>
                            {errorPassword && (
                                <p style={{margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute'}}>{errorPassword}</p>
                            )}
                    </div>

                    {/* ---- Masukin Data ConfPassword ---- */}
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="password-conf">Confirm Password</Label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input value={confPassword} onChange={changeConfPassword} type={showConfPass ? "text" : "password"} className="form-control pe-5" placeholder="Masukan Password kembali" id="password-conf" required minLength={8} maxLength={24}/>
                                <button className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted" onClick={showerConf} type="button" id="password-addon"><i className="ri-eye-fill align-middle"></i></button>
                            </div>
                            {errorConfPassword && (
                                <p style={{margin: '0', color: '#F56565', fontSize: '10px', position: 'absolute'}}>{errorConfPassword}</p>
                            )}
                    </div>

                    {/* ---- Masukin Data ConfPassword ---- */}
                    <div className="mb-3">
                        <Label className="form-label" htmlFor="password-conf">Special Unique Code</Label>
                            <div className="position-relative auth-pass-inputgroup">
                                <Input value={special} onChange={changeSpecial} type={"password"} className="form-control pe-5" placeholder="Masukan Unique Code" required minLength={8} maxLength={24}/>
                            </div>
                    </div>
                                                        
                    {/* ---- Daftar ---- */}
                    <div className="">
                        <Button type="submit" color="success" className="w-100" disabled={isDouble}
                        onClick={registerButton} >Daftar</Button>
                    </div>

                    <p style={{marginTop:'10px', marginBottom: '10px'}}>Sudah memiliki akun? <span style={{fontWeight: '700', color: '#F56565', cursor: 'pointer'}} onClick={() => {window.location.href = '/login-admin'}}> Masuk</span></p>

                </div>
            </Col>
        </Row>
        </React.Fragment>
    );
};

export default CoverSignUpterview;